// Export all constants from a single entry point
export * from './medicationConstants';
export * from './profileConstants';
export * from './turnstileConstants';
export * from './themeConstants';

/**
 * Application name constant
 * Used across the application for consistent branding
 */
export const APP_NAME = 'Meduler';

// Application-wide constants
export const CONSTANTS = {
  // Profile constants
  PROFILES: {
    DEFAULT_PROFILE_ID: 'u1',
    STORAGE_KEY: 'currentProfileId'
  },
  
  // Feature flags
  FEATURES: {
    PLUS_ENABLED: true,  // Using "Plus" as premium tier name per requirements
    OFFLINE_SUPPORT: true,
    ENABLE_PWA: true
  },
  
  // Application defaults
  APP: {
    DEFAULT_PORT: 3000,
    VERSION: process.env.VITE_APP_VERSION || '1.0.0'
  }
};
